module.exports = __webpack_public_path__ + "img/apidays.815b51a3.jpg";